import { PreferenceLocationMobile } from "app/(new-pages)/components/allSelect/PreferenceLocation/mobile";
import classNames from "classnames";
import React, { useState } from "react";

import styles from "./index.module.scss";
import { getCountryId } from "helpers/country";
import CascaderLocation from "components/Cascader";
interface Props {
  preference: any;
  onChange: (value: any) => void;
  value: any;
  placeholder: string;
  className?: string;
  text: {
    title: string;
    expandText: string;
    collapseText: string;
    inputPlaceholder: string;
  };
  showOtherCountry?: boolean;
  onOtherCountryClick?: () => void;
}

const PreferenceLocationForMobile = (props: Props) => {
  const {
    preference,
    onChange,
    text,
    value,
    placeholder = "",
    className = "",
    showOtherCountry,
    onOtherCountryClick
  } = props;

  const countryId = getCountryId();
  const showFirstLevel = /^(?:193|229|38|29|154|227|203|190)$/.test(String(countryId));

  const [open, setOpen] = useState(false);

  return (
    <>
      {showFirstLevel ? (
        <>
          <CascaderLocation {...props} suffixIcon={<ArrowIcon />} />
        </>
      ) : (
        <>
          <PreferenceLocationMobile
            open={open}
            onOpenChange={setOpen}
            preference={preference}
            onChange={onChange}
            text={{
              title: text?.title || "Job Title",
              expandText: text?.expandText || "Expand All",
              collapseText: text?.collapseText || "Collapse All",
              inputPlaceholder: text?.inputPlaceholder || "Enter a Job Title"
            }}
            showOtherCountry={showOtherCountry}
            onOtherCountryClick={() => {
              setOpen(false);
              onOtherCountryClick?.();
            }}
          />
          <div
            className={classNames(styles.jobFunction_selector, className)}
            onClick={() => setOpen(true)}
          >
            <span
              className={
                styles.jobFunction_value +
                " " +
                (value?.value ? "" : styles.jobFunction_placeholder)
              }
            >
              {value?.value ? value.label : placeholder}
            </span>
            <span className={styles.jobFunction_arrow}>
              <ArrowIcon />
            </span>
          </div>
        </>
      )}
    </>
  );
};

export default PreferenceLocationForMobile;

const ArrowIcon = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} fill='none' {...props}>
      <path
        fill='#000'
        fillRule='evenodd'
        d='m7.856 9.311-4.32-4.32a.667.667 0 0 0-.943 0l-.141.142a.667.667 0 0 0 0 .943l5.404 5.404 5.404-5.404a.667.667 0 0 0 0-.943l-.142-.141a.667.667 0 0 0-.942 0l-4.32 4.32Z'
        clipRule='evenodd'
      />
    </svg>
  );
};
